document.querySelectorAll('.tpt-size .accordion-header').forEach((header) => {
	header.addEventListener('click', () => {
		const content = header.nextElementSibling;
		const classContent = content.className;
		const icon = header.querySelector('i');
		if (content && !classContent.includes('active')) {
			content.classList.add('active');
			icon.classList.remove('fa-chevron-up');
			icon.classList.add('fa-chevron-down');
		} else {
			content.classList.remove('active');
			icon.classList.remove('fa-chevron-down');
			icon.classList.add('fa-chevron-up');
		}

		if (content.style.maxHeight) {
			content.style.maxHeight = null;
		} else {
			content.style.maxHeight = content.scrollHeight + 'px';
		}
	});
});

document.querySelectorAll('.tpt-size .accordion-item-header').forEach((header) => {
	header.addEventListener('click', () => {
		const content = header.nextElementSibling;
		const accordionItem = header.closest('.accordion-item');
		const accordionItemClass = accordionItem.className;
		const icon = header.querySelector('i');
		const accordionContent = header.closest('.accordion-content');
		const accordionItems = accordionContent.querySelectorAll('.accordion-item.active');

		accordionItems.forEach((item) => {
			item.classList.remove('active');
			const headerItem = item.querySelector('.accordion-item-header');
			const headerItemIcon = headerItem.querySelector('i');
			const contentItem = item.querySelector('.accordion-item-content');
			contentItem.style.maxHeight = null;
			headerItemIcon.classList.remove('fa-minus');
			headerItemIcon.classList.add('fa-plus');
		});

		if (content && !accordionItemClass.includes('active')) {
			accordionItem.classList.add('active');
			content.style.maxHeight = content.scrollHeight + 'px';
			accordionContent.style.maxHeight = accordionContent.scrollHeight + content.scrollHeight + 'px';
			icon.classList.remove('fa-plus');
			icon.classList.add('fa-minus');
		} else {
			accordionItem.classList.remove('active');
			content.style.maxHeight = null;
			icon.classList.remove('fa-minus');
			icon.classList.add('fa-plus');
		}
	});
});

document.querySelectorAll('.tpt-size .accordion-item-content div').forEach((contentEl) => {
	contentEl.addEventListener('click', () => {
		// CHANGE ACCORDION HEADER TEXT
		const accordion = contentEl.closest('.accordion');
		if (!accordion) return;
		const headerAccordionText = accordion.querySelector('.accordion-header span');
		const accordionItemActive = contentEl.closest('.accordion-item.active');
		const accordionItemActiveHeaderContent = accordionItemActive.querySelector('.accordion-item-header')?.innerText;
		const contentText = contentEl.innerText;
		headerAccordionText.innerText = `${accordionItemActiveHeaderContent} > ${contentText}`;

		// OPEN TABS LIST
		const sizeContainer = accordion.closest('.tpt-size');
		const pageSelectedClassRaw = `tpt-size-chart-${accordionItemActiveHeaderContent}-${contentText}`;
		const pageSelectedClass = pageSelectedClassRaw.toLocaleLowerCase().replaceAll("'", '').replaceAll(' ', '-').replaceAll('/', '-');
		const pageCurrentActive = sizeContainer.querySelector('.page-item.active');
		if (pageCurrentActive) pageCurrentActive.classList.remove('active');
		const selectedPage = sizeContainer.querySelector(`.${pageSelectedClass}`);
		if (selectedPage) selectedPage.classList.add('active');

		// OPEN TABS CONTENT
		const tabContent = selectedPage.querySelector('.tab-content');
		if (tabContent) tabContent.classList.add('active');

		// CLOSED ACCORDION CONTENT
		const contentAccordion = accordion.querySelector('.accordion-header + .accordion-content');
		if (contentAccordion) {
			contentAccordion.classList.toggle('active');
			contentAccordion.style.maxHeight = null;
		}
	});
});

document.querySelectorAll('.tpt-size .tab').forEach((tab) => {
	tab.addEventListener('click', () => {
		const pageItem = tab.closest('.page-item');
		pageItem.querySelectorAll('.tab').forEach((t) => t.classList.remove('active'));
		pageItem.querySelectorAll('.tab-content').forEach((tc) => tc.classList.remove('active'));
		tab.classList.add('active');
		pageItem.querySelectorAll('.tab-content')[Array.from(tab.parentNode.children).indexOf(tab)].classList.add('active');
	});
});

// HANDLE HOVER CELL
function clearTableStyles(table) {
	table.querySelectorAll('th, td, tr').forEach(function (cell) {
		cell.classList.remove('selected-table-element', 'cross-section-header', 'cross-section-data', 'cross-section-row');
	});
}

function highlightCell(cell) {
	const highlightClass = cell.tagName.toLowerCase() === 'th' ? 'cross-section-header' : 'cross-section-data';
	cell.classList.add(highlightClass);
}

function handleCellHover(event) {
	const hoveredCell = event.target;
	const parentRow = hoveredCell.closest('tr');
	const hasDataCells = parentRow && parentRow.querySelectorAll('td').length > 0;
	const cellIndex = Array.from(hoveredCell.parentElement.children).indexOf(hoveredCell);
	const parentRowIndex = Array.from(parentRow.parentElement.children).indexOf(parentRow);
	const table = hoveredCell.closest('table');

	if (!table) return;

	clearTableStyles(table);
	const hoveredCellTagName = hoveredCell.tagName.toLowerCase();
	if (hoveredCellTagName != 'td' && hoveredCellTagName != 'th') {
		const cellParrent = hoveredCell.closest('th') || hoveredCell.closest('td');
		cellParrent.classList.add('selected-table-element');
		console.log('cellParrent', cellParrent);
	}
	if (hoveredCellTagName === 'td' || hoveredCellTagName === 'th') hoveredCell.classList.add('selected-table-element');
	if (parentRow) parentRow.classList.add('cross-section-row');

	if (hasDataCells && cellIndex >= 0) {
		table.querySelectorAll('tr').forEach(function (row) {
			if (row.querySelector('td.selected-table-element')) {
				row.querySelectorAll('th, td').forEach(function (cell, index) {
					if (index < cellIndex) {
						highlightCell(cell);
					}
				});
				return;
			} else {
				const rowIndex = Array.from(row.parentElement.children).indexOf(row);
				if (rowIndex > parentRowIndex) return;
				const targetCell = row.querySelectorAll('th, td')[cellIndex];
				if (targetCell) {
					highlightCell(targetCell);
				}
			}
		});
	}
}

// Attach event listeners to all tables on the page
document.addEventListener('DOMContentLoaded', function () {
	const tables = document.querySelectorAll('table.size-chart');

	tables.forEach(function (table) {
		table.addEventListener('mouseover', handleCellHover);

		// Remove all added classes when the mouse leaves the table
		table.addEventListener('mouseleave', function () {
			clearTableStyles(table);
		});
	});
});
// HANDLE HOVER CELL

// HANDLE CONVERT SIZE
function roundToHalf(num) {
	return Math.round(num * 4) / 4;
}

function roundOneDecimal(num) {
	return Math.round(num * 10) / 10;
}

function convertSize(value, type) {
	const numberValue = parseFloat(value);
	if (isNaN(numberValue)) return value;
	if (type === 'inches-to-cm') return roundOneDecimal(numberValue * 2.54);
	if (type === 'cm-to-inches') return roundToHalf(numberValue / 2.54);
}

function convertSizeTable(tds, convertType) {
	tds.forEach((td) => {
		const content = td.innerText.replaceAll('–', '-');
		let splitContent = content.includes('-') ? content.split('-') : [content];
		const checkNotNumber = splitContent.find((content) => isNaN(parseFloat(content)));
		if (checkNotNumber) return;
		const newSplitContent = splitContent.map((content) => convertSize(content, convertType));
		const newContent = newSplitContent.join(' - ');
		td.innerText = newContent;
	});
}

document.querySelectorAll('.tpt-size .toggle-container').forEach((toggleContainer) => {
	const toggleSwitch = toggleContainer.querySelector('.toggle-switch');
	const tabActive = toggleSwitch.closest('.tab-content.active');
	const tds = tabActive.querySelectorAll('table.size-chart td');
	toggleSwitch?.addEventListener('click', () => {
		if (!toggleSwitch.classList.contains('active')) convertSizeTable(tds, 'inches-to-cm');
		else convertSizeTable(tds, 'cm-to-inches');
		toggleSwitch.classList.toggle('active');
	});
});
// HANDLE CONVERT SIZE
